import { useMemo } from 'react';

/**
 * Returns a fresh, meaningless field name per mount so Chrome's autofill matcher
 * (and Google's crowdsourced field-name predictions) have nothing recognizable
 * to key off of. `id` is left untouched since label htmlFor, getPathFromId, and
 * test ids depend on it.
 */
export function useAutofillSafeName(): string {
  return useMemo(() => `f-${Math.random().toString(36).slice(2, 10)}`, []);
}
